import React, { Component } from "react";
import MilestoneTable from "./MilestoneTable";
import { integer_to_roman } from "./milestone.helper";
import { Button, Form, Image } from "react-bootstrap";
import { get, isObject } from "lodash";
import { DatePicker } from "../../../component";
import { DatePickerStyled } from "../../../component/DatePickerMilestone";
import {
  getLocalstorage,
  isValidArray,
  normalizeId,
  zeroToEmpty
} from "../../../helper";
import deletePhaseIcon from "../../../assets/deleteBinIcon.png";
import EyeShow from "../../../assets/eye-icon.svg";
import EyeHide from "../../../assets/eye-off.svg";
import StateWiseCostModal from "../stateWiseCostModal";
import {
  getCostDistributionData,
  updateCostDistributionData
} from "../../../services/apiServices";
import request from "../../../services/requestService";
import { toast } from "react-toastify";
import { errorToastStyle, successToastStyle } from "../../../customToast";
import { getDistrictListForLocation } from "../../../actions/createProject.action";
class MultipleMilestoneTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tableArr: props.milestoneTableDataCOS || [{}],
      costData: {},
      showOriginalModal: false,
      milestoneState: [],
      totalOriginalCost: [],
      totalProgress: {},
      bucketId: 0,
      index: 0,
      activeTableIndex: null,
      dataFromMileTable: {},
      localStateWiseData: {},
      statewiseId: {}
    };
  }

  componentDidMount() {
    const {
      draftMilestoneAction,
      bucketMilestoneCOS,
      costDistributionData,
      stateWiseData
    } = this.props;
    draftMilestoneAction(bucketMilestoneCOS);

    if (this.props.projectId) {
      const getCostData = request(
        getCostDistributionData({
          projectId: this.props.projectId,
          active: true
        })
      );
      getCostData.then(resp => {
        const locationDetail = window.location.pathname == "/detail-project";
        const rawData = resp.data.data;
        this.setState({
          dataFromMileTable: resp.data.data,
          localStateWiseData: !locationDetail
            ? resp.data.data
            : this.props.costDistributionData
        });
        const tableData = Object.values(rawData || {}).flat();
        const totalCost = tableData.reduce(
          (sum, item) => sum + Number(item.totalProjectCost),
          ""
        );
        const totalInstalled = tableData.reduce(
          (sum, item) => sum + Number(item.totalOFCInstalled || 0),
          0
        );
        const totalPlanned = tableData.reduce(
          (sum, item) => sum + Number(item.totalOFCPlanned || 0),
          0
        );
        const progress =
          totalPlanned > 0
            ? ((totalInstalled / totalPlanned) * 100).toFixed(2)
            : "";
        this.setState({
          totalOriginalCost: totalCost
          // totalProgress: progress
        });
        const apiIndexedData = rawData || {};
        const allStates = this.props.locations.map(l => l.name);

        const mergedStateWiseData = this.mergeStatesIntoIndexedData(
          apiIndexedData,
          allStates
        );
        this.setState({
          costData: rawData
        });
      });
    }
    const costData = this.state.costData.length
      ? this.state.costData
      : costDistributionData != undefined && Array.isArray(costDistributionData)
      ? costDistributionData
      : Array.isArray(stateWiseData)
      ? stateWiseData
      : [];

    const totalCost = costData.reduce(
      (sum, item) => sum + Number(item.totalProjectCost),
      ""
    );
    const totalInstalled = costData.reduce(
      (sum, item) => sum + Number(item.totalOFCInstalled || 0),
      0
    );
    const totalPlanned = costData.reduce(
      (sum, item) => sum + Number(item.totalOFCPlanned || 0),
      0
    );
    const progress =
      totalPlanned > 0
        ? ((totalInstalled / totalPlanned) * 100).toFixed(2)
        : "";
    this.setState({ totalOriginalCost: totalCost, totalProgress: progress });
  }
  normalize = v =>
    String(v || "")
      .trim()
      .toLowerCase();

  emptyRow = state => ({
    stateOrUT: state,
    totalLocationsUncovered: "",
    totalLocationsConnected: "",
    totalOFCPlanned: "",
    totalOFCInstalled: "",
    totalProjectCost: "",
    implementationAgency: "",
    physicalProgressPercentage: "",
    active: true
  });

  resolveHeadersForIndex = (rows = [], fallbackRows = []) => {
    const headers = {};
    const HEADER_KEYS = [
      "totalLocationsUncoveredHeader",
      "totalLocationsConnectedHeader",
      "totalOFCPlannedHeader",
      "totalOFCInstalledHeader"
    ];
    rows.some(row => {
      HEADER_KEYS.forEach(k => {
        if (!headers[k] && row[k] && row[k] !== "Select") {
          headers[k] = row[k];
        }
      });
      return Object.keys(headers).length === HEADER_KEYS.length;
    });
    if (fallbackRows.length) {
      fallbackRows.some(row => {
        HEADER_KEYS.forEach(k => {
          if (!headers[k] && row[k] && row[k] !== "Select") {
            headers[k] = row[k];
          }
        });
        return Object.keys(headers).length === HEADER_KEYS.length;
      });
    }

    return headers;
  };

  mergeStatesIntoIndexedData = (indexedData = {}, allStates = []) => {
    const result = {};

    const fallbackRows = Array.isArray(indexedData[0]) ? indexedData[0] : [];

    Object.keys(indexedData).forEach(index => {
      const rows = Array.isArray(indexedData[index]) ? indexedData[index] : [];

      const rowMap = {};
      rows.forEach(row => {
        if (row.stateOrUT) {
          rowMap[this.normalize(row.stateOrUT)] = row;
        }
      });

      const headers = this.resolveHeadersForIndex(rows, fallbackRows);

      result[index] = allStates.map(state => {
        const key = this.normalize(state);

        return rowMap[key]
          ? {
              ...rowMap[key],
              ...headers,
              stateOrUT: state,
              active: true
            }
          : {
              ...this.emptyRow(state),
              ...headers
            };
      });
    });

    return result;
  };
  ZIndex = value => {
    this.props.ZIndex(value);
  };
  getCostApiCall = () => {
    const getCostData = request(
      getCostDistributionData({
        projectId: this.props.projectId,
        active: true
      })
    );
    getCostData.then(resp => {
      this.setState({ dataFromMileTable: resp.data.data });
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { bucketId, milestoneTableDataCOS } = this.props;
    const {
      bucketId: prevBucketId,
      milestoneTableDataCOS: prevMilestoneTableDataCOS
    } = prevProps;

    if (
      (!!bucketId && prevBucketId !== bucketId) ||
      prevMilestoneTableDataCOS !== milestoneTableDataCOS
    ) {
      this.setState({
        tableArr: milestoneTableDataCOS
      });
    }
  }

  addPhase = e => {
    const { bucketId, onChange } = this.props;
    this.setState(prevState => ({
      tableArr: prevState.tableArr.concat({})
    }));
    onChange("", "addphase", bucketId);
  };

  getCostDistributionCall = () => {
    const getCostData = request(
      getCostDistributionData({
        projectId: this.props.projectId,
        active: true
      })
    );
    getCostData.then(resp => {
      this.setState({
        localStateWiseData: resp.data.data,
        dataFromMileTable: resp.data.data
      });
    });
  };

  deletePhase = index => {
    const { bucketId, onChange, onStateWisePhaseChange } = this.props;
    let array = [...this.state.tableArr];
    this.props.deleteStateWiseData(index);
    this.setState(prev => {
      const costData = { ...(prev.costData || {}) };
      const localStateWiseData = { ...(prev.localStateWiseData || {}) };
      const dataFromMileTable = { ...(prev.dataFromMileTable || {}) };
      delete dataFromMileTable[index];
      delete localStateWiseData[index];
      delete costData[index];
      if (
        window.location.pathname == "/create-project" &&
        getLocalstorage("draftedProject")
      ) {
        onStateWisePhaseChange(index);
      }
      return { costData, localStateWiseData, dataFromMileTable };
    });
    if (
      window.location.pathname == "/create-project" &&
      getLocalstorage("draftedProject")
    )
      setTimeout(() => {
        this.getCostDistributionCall();
      }, 2000);
    array.splice(index, 1);
    this.setState({ tableArr: array });
    onChange(index, "deletePhase", bucketId, null, null, index);
  };

  getDefaultBucketMilestones = (bucketId, milestoneData) => {
    const bucketIndex = milestoneData.findIndex(
      mbucket => mbucket.bucket.id == bucketId
    );
    let defaultMilestones = [];
    if (
      !!milestoneData[bucketIndex] &&
      !!milestoneData[bucketIndex].milestones
    ) {
      defaultMilestones = milestoneData[bucketIndex].milestones.filter(
        item => item.predefined === true
      );
    }
    return defaultMilestones;
  };

  getState = async row => {
    if (
      row.stateOrUT ||
      (row.districtList &&
        Array.isArray(row.districtList) &&
        row.districtList.length > 0)
    ) {
      return row.stateOrUT || row.districtList[0].stateName;
    }

    try {
      const resp = await getDistrictListForLocation(undefined, row.id);

      if (resp && Array.isArray(resp.data) && resp.data.length > 0) {
        return resp.data[0].stateName;
      }
    } catch (e) {}

    return "";
  };

  isEmptyArray = arr =>
    !Array.isArray(arr) ||
    arr.length === 0 ||
    arr.every(obj => !obj || Object.keys(obj).length === 0);

  openOriginalModal = async (e, bucketId, ind) => {
    if (e && e.target && typeof e.target.blur === "function") {
      e.target.blur();
    }

    const checkEmpty = this.isEmptyArray(this.props.locations);

    const smallIdSet =
      checkEmpty && Array.isArray(this.props.draftLocation)
        ? new Set(
            this.props.draftLocation
              .map(item => normalizeId(item.stateId))
              .filter(Boolean)
          )
        : new Set(
            this.props.locations
              .map(item => normalizeId(item.id))
              .filter(Boolean)
          );

    const filteredBigArray = this.props.pageDetail.filter(item => {
      const id = normalizeId(item.id);
      const state = item.name || item.state;
      return state && smallIdSet.has(id);
    });

    this.setState({ filteredBigArray: filteredBigArray });
    const stateNames = filteredBigArray
      .map(item => item.name || item.state)
      .filter(Boolean);

    this.setState(prev => {
      const localStateWiseData = { ...prev.localStateWiseData };

      if (window.location.pathname === "/detail-project") {
        return {
          showOriginalModal: !prev.showOriginalModal,
          bucketId,
          index: ind,
          activeTableIndex: ind,
          localStateWiseData: this.state.localStateWiseData
        };
      }

      const adjustedMasterStates = [
        ...new Set(stateNames.map(loc => loc).filter(Boolean))
      ];
      const locationStates = new Set(
        (Array.isArray(stateNames) ? stateNames : [])
          .map(loc => loc)
          .filter(Boolean)
      );

      let existingRows = [];

      if (
        window.location.pathname === "/create-project" &&
        getLocalstorage("draftedProject") &&
        Array.isArray(prev.dataFromMileTable[ind])
      ) {
        existingRows = prev.dataFromMileTable[ind].filter(
          row => row.stateOrUT && locationStates.has(row.stateOrUT)
        );
      } else {
        existingRows =
          (Array.isArray(this.props.stateWiseData[ind]) &&
            this.props.stateWiseData[ind]) ||
          (Array.isArray(prev.costData[ind]) && prev.costData[ind]) ||
          (Array.isArray(localStateWiseData[ind]) && localStateWiseData[ind]) ||
          [];
      }
      const HEADER_KEYS = [
        "totalLocationsUncoveredHeader",
        "totalLocationsConnectedHeader",
        "totalOFCPlannedHeader",
        "totalOFCInstalledHeader"
      ];

      const existingMap = {};
      existingRows.forEach(row => {
        if (row.stateOrUT && locationStates.has(row.stateOrUT)) {
          existingMap[row.stateOrUT] = { ...row };
        }
      });

      const headerSource =
        existingRows.find(row =>
          HEADER_KEYS.some(k => row[k] && row[k] !== "Select")
        ) || {};
      const headersToCopy = HEADER_KEYS.reduce((acc, k) => {
        if (headerSource[k]) acc[k] = headerSource[k];
        return acc;
      }, {});

      localStateWiseData[ind] = adjustedMasterStates.map(state => {
        const saved = existingMap[state] || {};

        return {
          stateOrUT: state,
          ...headersToCopy,
          id: saved.id || null,
          totalLocationsUncovered:
            saved.totalLocationsUncovered !== undefined &&
            saved.totalLocationsUncovered !== null
              ? saved.totalLocationsUncovered
              : "",
          totalLocationsConnected:
            saved.totalLocationsConnected !== undefined &&
            saved.totalLocationsConnected !== null
              ? saved.totalLocationsConnected
              : "",
          totalOFCPlanned:
            saved.totalOFCPlanned !== undefined &&
            saved.totalOFCPlanned !== null
              ? saved.totalOFCPlanned
              : "",
          totalOFCInstalled:
            saved.totalOFCInstalled !== undefined &&
            saved.totalOFCInstalled !== null
              ? saved.totalOFCInstalled
              : "",
          totalProjectCost:
            saved.totalProjectCost !== undefined &&
            saved.totalProjectCost !== null
              ? saved.totalProjectCost
              : "",
          implementationAgency: saved.implementationAgency || "",
          physicalProgressPercentage:
            // saved.physicalProgressPercentage || "",
            saved.physicalProgressPercentage !== undefined &&
            saved.physicalProgressPercentage !== null
              ? saved.physicalProgressPercentage
              : "",

          active: true
        };
      });
      const safeIndex = Number.isInteger(prev.activeTableIndex)
        ? prev.activeTableIndex
        : ind;

      return {
        showOriginalModal: !prev.showOriginalModal,
        bucketId,
        index: ind,
        activeTableIndex: ind,
        costData: {
          ...prev.costData,
          [safeIndex]: localStateWiseData[safeIndex]
        },
        localStateWiseData
      };
    });
  };

  handleStateWiseData = (data, index) => {
    this.setState(prev => ({
      dataFromMileTable: {
        ...prev.dataFromMileTable,
        [index]: data
      }
    }));
    const locationDetail = window.location.pathname == "/detail-project";
    const locationCreate = window.location.pathname == "/create-project";
    const costDistributionData = locationDetail
      ? this.state.dataFromMileTable
      : locationCreate && !getLocalstorage("draftedProject")
      ? this.state.localStateWiseData
      : this.state.dataFromMileTable;
    this.setState(prev => {
      const localState = prev.localStateWiseData;
      localState[index] = data;
      return { localStateWiseData: localState };
    });
    if (locationDetail) {
      this.setState(prev => {
        const updatedCostData = Array.isArray(prev.costData)
          ? [...prev.costData]
          : [];
        const stateWiseUpdate = Array.isArray(prev.statewiseId)
          ? [...prev.statewiseId]
          : [];
        updatedCostData[index] = data;

        return {
          statewiseId: stateWiseUpdate,
          costData: updatedCostData,
          localStateWiseData: {
            ...prev.localStateWiseData,
            [index]: data
          }
        };
      });
    }

    const idsFromIndex = Array.isArray(costDistributionData[index])
      ? costDistributionData[index].map(item => ({
          id: item.id,
          stateOrUT: item.stateOrUT
        }))
      : [];

    let updated;

    const { projectId } = this.props;
    if (projectId) {
      const seenStates = new Set();
      const idByState = {};
      idsFromIndex.forEach(({ id, stateOrUT }) => {
        if (id && stateOrUT && !idByState[stateOrUT]) {
          idByState[stateOrUT] = id;
        }
      });

      updated = data
        .filter(item => {
          if (!item.stateOrUT) return false; // optional safeguard

          if (seenStates.has(item.stateOrUT)) return false;

          seenStates.add(item.stateOrUT);
          return true;
        })
        .map((item, ind) => ({
          ...item,
          id: idByState[item.stateOrUT] || null,
          projectId: projectId
        }));
      const tableIndex = data[0].tableIndex;
      const prevId =
        (this.state.statewiseId && this.state.statewiseId[tableIndex]) || [];
      const updatedData = updated.map((item, ind) => ({
        ...item,
        id: prevId[ind] || item.id || null
      }));
      this.props.updatedCall(updatedData, index);
      if (getLocalstorage("draftedProject") && !locationDetail) {
        toast.success(
          <p className="toast-text-alignment">{"Updated Successfully"}</p>,
          successToastStyle
        );
      }
      if (locationDetail) {
        const postData = request(updateCostDistributionData(updatedData));
        postData.then(resp => {
          if (resp.data.status) {
            this.setState(prev => ({
              statewiseId: {
                ...(prev.statewiseId || {}),
                [tableIndex]: resp.data.data
              }
            }));
            toast.success(
              <p className="toast-text-alignment">{"Updated Successfully"}</p>,
              successToastStyle
            );
          } else {
            toast.error(
              <p className="toast-text-alignment">{"Something Went Wrong!"}</p>,
              errorToastStyle
            );
          }
        });
      }
    }
    // setTimeout(() => {
    //   this.getCostApiCall();
    // }, 2000);
    this.props.handleStateWiseData(data, index);
    this.state.totalOriginalCost = data.reduce(
      (sum, item) => sum + Number(item.totalProjectCost || 0),
      0
    );

    this.setState({ showOriginalModal: !this.state.showOriginalModal });
    this.props.onChange(
      this.state.totalOriginalCost,
      "phaseOriginalCost",
      this.state.bucketId,
      null,
      null,
      this.state.index
    );
  };

  calculateTotalCost = (stateWiseData, index) => {
    const rows = stateWiseData && stateWiseData[index];

    if (!Array.isArray(rows)) return "";

    const total = rows.reduce(
      (sum, row) => sum + Number(row.totalProjectCost || 0),
      0
    );

    const hasAnyValidCost = rows.some(
      row =>
        row.totalProjectCost !== null &&
        row.totalProjectCost !== undefined &&
        row.totalProjectCost !== ""
    );

    return (total === 0 && !this.props.projectId) ||
      // (rows && rows[0].totalProjectCost == undefined)
      !hasAnyValidCost
      ? ""
      : total;
  };

  calculatePhysicalProgress = (stateWiseData, index) => {
    const rows = stateWiseData && stateWiseData[index];

    if (!Array.isArray(rows)) return "";
    const totalInstalled = rows.reduce(
      (sum, row) => sum + Number(row.totalOFCInstalled || 0),
      0
    );
    const totalPlanned = rows.reduce(
      (sum, row) => sum + Number(row.totalOFCPlanned || 0),
      0
    );
    const isNan = Number.isNaN(
      Number(((totalInstalled / totalPlanned) * 100).toFixed(2))
    );
    return isNan || (this.props.projectId && totalInstalled / totalPlanned == 0)
      ? 0
      : ((totalInstalled / totalPlanned) * 100).toFixed(2);
    // : "";
  };

  getProgressSource = () => {
    if (
      this.state.costData &&
      Object.keys(this.state.costData).length >
        Object.keys(this.props.stateWiseData).length
    ) {
      return this.state.costData; // ✅ latest edits
    }

    if (
      this.props.stateWiseData &&
      Object.keys(this.props.stateWiseData).length !== 0
    ) {
      return this.props.stateWiseData;
    }

    return this.props.costDistributionData;
  };

  render() {
    const { tableArr } = this.state;
    const {
      milestoneData,
      bucketId,
      onChange,
      // milestoneDataCOS,
      responsibleAuthority,
      milestoneTableDataCOS,
      bucketMilestoneCOS,
      createMilestoneAction,
      saveNewMilestoneAction,
      deleteNewMilestoneAction,
      openedFromComplete,
      milestoneError,
      isBucketDisabled,
      handleTableOrder,
      displayButtonForComplete,
      draftMilestoneAction,
      isBucketCompleted,
      openMilestoneEdit,
      groupCategory,
      projectDetailBucketMilestoneCOS,
      checkIssueBeforeDeletion,
      projectId,
      checkIssueBeforeDisable,
      projectMilestoneStatus,
      _selectedBucketData,
      userID,
      userInfo,
      projectPPList,
      createdBy,
      isMilestoneTableValidated,
      editMilestoneOriginalDate,
      showPhases,
      cabinetMilestone,
      sponsoredByCategory,
      isEdit,
      cabinetbucketId,
      isCabinetMilestoneMandatoryExempt,
      isCabinetMilestoneMandatoryEditExempt
    } = this.props;
    let projectDetailBucketMilestone = (
      projectDetailBucketMilestoneCOS || []
    ).map(item => parseInt(item.milestoneTableDataCOS.length));
    const userInformation = getLocalstorage("user");
    const isUserPMG = get(userInformation, "groupCategory") === "PMG";
    // console.log("from multiple mile stone table", bucketMilestoneCOS);

    //For Project Proponent Dropdown
    let _projectPPList = [];
    let userInfoObj = {
      id: get(userInfo, "id", null),
      name: get(userInfo, "name", ""),
      userID: get(userInfo, "userID", "")
    };
    let checkUserID = !isObject(userID) && userID !== null;
    let userIDObj = {
      id: !!checkUserID ? get(createdBy, "id", null) : get(userID, "id", null),
      name: !!checkUserID
        ? get(createdBy, "name", null)
        : get(userID, "name", ""),
      userID: !!checkUserID
        ? get(createdBy, "userID", null)
        : get(userID, "userID", "")
    };
    if (isValidArray(projectPPList)) {
      _projectPPList = projectPPList;
    } else {
      if (userIDObj.id !== null) {
        _projectPPList = [userIDObj];
      } else {
        _projectPPList = [userInfoObj];
      }
    }
    // console.log(cabinetMilestone)
    return (
      <div>
        {tableArr &&
          tableArr.length &&
          tableArr.map((item, index) => {
            let selectedPhase =
              _selectedBucketData &&
              _selectedBucketData.milestoneTableDataCOS &&
              _selectedBucketData.milestoneTableDataCOS[index];
            // console.log(selectedPhase)
            let selectedPhaseName =
              get(selectedPhase, "phaseName", "") ==
              "Cabinet_Milestone_Phase (1)"
                ? ""
                : get(selectedPhase, "phaseName", "");
            let selectedPhysicalProgress = get(
              selectedPhase,
              "physicalPercentage",
              ""
            );
            let selectedFinancialProgress = get(
              selectedPhase,
              "financialPercentage",
              ""
            );
            let selectedAsOfDate = get(selectedPhase, "asOfDate", "");
            let selectedPhaseOriginalCost = get(
              selectedPhase,
              "phaseOriginalCost",
              ""
            );
            let selectedPhaseRevisedCost = get(
              selectedPhase,
              "phaseRevisedCost",
              ""
            );

            let selectedPhaseProponentId = get(
              selectedPhase,
              "phaseProponentId",
              ""
            );
            let canDeletePhase = isUserPMG
              ? tableArr.length !== 1
              : tableArr.length !== 1 &&
                index >= Math.max(...projectDetailBucketMilestone);
            const isDraft = getLocalstorage("draftedProject");

            const stateWiseData = isDraft
              ? this.state.costData &&
                this.state.costData[this.state.activeTableIndex] &&
                this.state.costData[this.state.activeTableIndex].length
                ? this.state.costData[this.state.activeTableIndex]
                : (this.props.stateWiseData &&
                    this.props.stateWiseData[this.state.activeTableIndex]) ||
                  []
              : this.props.stateWiseData[this.state.activeTableIndex] || [];

            let resolvedStateWiseData = [];
            if (
              window.location.pathname === "/detail-project"
              // (Array.isArray(this.state.localStateWiseData[0]) &&
              //   this.state.localStateWiseData[0].length) <
              //   (Array.isArray(this.props.costDistributionData[0]) &&
              //     this.props.costDistributionData[0].length)
            ) {
              resolvedStateWiseData = this.state.localStateWiseData[
                this.state.activeTableIndex
              ];
            } else if (window.location.pathname === "/detail-project") {
              resolvedStateWiseData = this.state.localStateWiseData[
                this.state.activeTableIndex
              ];
            } else if (
              getLocalstorage("draftedProject") ||
              window.location.pathname === "/create-project"
              // (Array.isArray(this.state.localStateWiseData[0]) &&
              //   this.state.localStateWiseData[0].length) <
              // (Array.isArray(this.state.costData[0]) &&
              //   this.state.costData[0].length)
            ) {
              resolvedStateWiseData =
                this.state.localStateWiseData[this.state.activeTableIndex] ||
                [];
            } else if (window.location.pathname === "/create-project") {
              resolvedStateWiseData = this.state.localStateWiseData[
                this.state.activeTableIndex
              ];
            } else {
              resolvedStateWiseData =
                this.props.stateWiseData[this.state.activeTableIndex] ||
                stateWiseData;
            }

            return (
              <React.Fragment>
                <div
                  className={
                    _selectedBucketData && !_selectedBucketData.completed
                      ? ""
                      : "phase-complete-bucket"
                  }
                >
                  <div
                    className={
                      _selectedBucketData && !_selectedBucketData.completed
                        ? "phase-for-bucket"
                        : "phase-for-bucket bucket-phase-complete"
                    }
                  >
                    <div
                      className={`${
                        _selectedBucketData &&
                        _selectedBucketData.completed &&
                        editMilestoneOriginalDate
                          ? "phase-index-name"
                          : _selectedBucketData && _selectedBucketData.completed
                          ? "phase-title"
                          : "phase-on-notcomplete"
                      } d-flex justify-content-between `}
                      style={{
                        visibility:
                          _selectedBucketData &&
                          _selectedBucketData.bucketName == "Cabinet Milestone"
                            ? "hidden"
                            : null,
                        marginTop:
                          _selectedBucketData &&
                          _selectedBucketData.bucketName == "Cabinet Milestone"
                            ? "-3em"
                            : null
                      }}
                    >
                      <div
                        className={
                          "phase-index" +
                          (isBucketDisabled ? " hide-table" : "")
                        }
                        data-test="label-phase-index"
                      >
                        {" "}
                        PHASE ({integer_to_roman(index + 1)})
                      </div>
                    </div>
                    <div
                      className={`milestone-table-header ${
                        _selectedBucketData &&
                        _selectedBucketData.completed &&
                        editMilestoneOriginalDate
                          ? "phase-header"
                          : !_selectedBucketData.completed
                          ? "phase-header-noncomplete"
                          : "phase-header-complete"
                      } ${isBucketDisabled ? "hide-table" : ""}`}
                      style={{
                        display:
                          _selectedBucketData &&
                          _selectedBucketData.bucketName == "Cabinet Milestone"
                            ? "none"
                            : null
                      }}
                    >
                      {/* Phase Name */}
                      <div className="phase-name-wrapper">
                        <div
                          className="table-name"
                          data-test="label-phase-name"
                        >
                          Phase Name
                        </div>

                        <Form.Group>
                          <div className="form-field">
                            <Form.Control
                              type="text"
                              placeholder={`Enter Phase Name`}
                              onChange={e => {
                                onChange(
                                  e.target.value,
                                  "phaseName",
                                  bucketId,
                                  null,
                                  null,
                                  index
                                );
                              }}
                              value={selectedPhaseName ? selectedPhaseName : ""}
                            />
                          </div>
                        </Form.Group>
                      </div>
                      {/* Original Cost */}
                      <div className="phase-name-wrapper progress-wrapper cost-fields">
                        <div
                          className="table-name"
                          data-test="label-original-cost"
                        >
                          Original Cost (Cr.)
                        </div>
                        <Form.Group>
                          <div className="form-field">
                            <span className="percent-prefix">&#8377;</span>
                            <Form.Control
                              type="number"
                              // readOnly={
                              //   this.props.groupId === 166 ||
                              //   this.state.totalOriginalCost
                              // }
                              onChange={
                                this.props.groupId !== 166
                                  ? e => {
                                      onChange(
                                        e.target.value,
                                        "phaseOriginalCost",
                                        bucketId,
                                        null,
                                        null,
                                        index
                                      );
                                    }
                                  : undefined
                              }
                              onClick={
                                this.props.groupId == 166
                                  ? e =>
                                      this.openOriginalModal(e, bucketId, index)
                                  : undefined
                              }
                              value={
                                window.location.pathname == "/create-project" &&
                                this.props.groupId == 166
                                  ? this.calculateTotalCost(
                                      this.props.stateWiseData,
                                      index
                                    ) || 0
                                  : this.props.groupId == 166 &&
                                    Object.keys(this.state.localStateWiseData)
                                      .length !== 0
                                  ? this.calculateTotalCost(
                                      this.state.localStateWiseData,
                                      index
                                    ) || 0
                                  : this.props.groupId == 166 &&
                                    Object.keys(this.state.costData).length !==
                                      0
                                  ? this.calculateTotalCost(
                                      this.state.costData,
                                      index
                                    )
                                  : this.props.groupId == 166 &&
                                    Object.keys(this.props.stateWiseData || {})
                                      .length === 0
                                  ? this.calculateTotalCost(
                                      this.props.costDistributionData,
                                      index
                                    )
                                  : selectedPhaseOriginalCost
                                  ? selectedPhaseOriginalCost
                                  : ""
                              }
                            />
                            <span className="percent-suffix">Cr.</span>
                          </div>
                        </Form.Group>
                        {this.state.showOriginalModal &&
                          this.state.activeTableIndex === index && (
                            <StateWiseCostModal
                              show={true}
                              projectId={projectId}
                              onHide={e =>
                                this.openOriginalModal(e, null, null)
                              }
                              // locations={this.props.locations}
                              locations={this.state.filteredBigArray}
                              handleStateWiseData={this.handleStateWiseData}
                              costDistributionData={
                                Array.isArray(this.state.costData) &&
                                this.state.costData[this.state.activeTableIndex]
                              }
                              stateWiseData={resolvedStateWiseData}
                              tableIndex={this.state.activeTableIndex}
                              bucketId={bucketId}
                            />
                          )}
                      </div>
                      {/* Revised Cost */}
                      <div className="phase-name-wrapper progress-wrapper cost-fields">
                        <div
                          className="table-name"
                          data-test="label-revised-cost"
                        >
                          Revised Cost (Cr.)
                        </div>
                        <Form.Group>
                          <div className="form-field">
                            <span className="percent-prefix">&#8377;</span>
                            <Form.Control
                              type="number"
                              // disabled={this.props.groupId == 166}
                              onChange={e => {
                                onChange(
                                  e.target.value,
                                  "phaseRevisedCost",
                                  bucketId,
                                  null,
                                  null,
                                  index
                                );
                              }}
                              value={
                                selectedPhaseRevisedCost
                                  ? selectedPhaseRevisedCost
                                  : ""
                              }
                            />
                            <span className="percent-suffix">Cr.</span>
                          </div>
                        </Form.Group>
                      </div>
                      {/* Physical Progress */}
                      <div className="phase-name-wrapper progress-wrapper">
                        <div
                          className="table-name"
                          data-test="label-physical-progress"
                        >
                          Physical Progress
                        </div>
                        <Form.Group>
                          <div className="form-field">
                            <Form.Control
                              type="number"
                              onChange={
                                this.props.groupId !== 166
                                  ? e => {
                                      onChange(
                                        e.target.value,
                                        "physicalProgress",
                                        bucketId,
                                        null,
                                        null,
                                        index
                                      );
                                    }
                                  : undefined
                              }
                              onClick={
                                this.props.groupId == 166
                                  ? e =>
                                      this.openOriginalModal(e, bucketId, index)
                                  : undefined
                              }
                              value={
                                window.location.pathname == "/create-project" &&
                                this.props.groupId == 166
                                  ? this.calculatePhysicalProgress(
                                      this.props.stateWiseData,
                                      index
                                    ) || 0
                                  : this.props.groupId == 166 &&
                                    Object.keys(this.state.localStateWiseData)
                                      .length !== 0
                                  ? this.calculatePhysicalProgress(
                                      this.state.localStateWiseData,
                                      index
                                    ) || 0
                                  : this.props.groupId == 166 &&
                                    Object.keys(this.state.costData).length !==
                                      0
                                  ? this.calculatePhysicalProgress(
                                      this.state.costData,
                                      index
                                    )
                                  : this.props.groupId == 166 &&
                                    Object.keys(this.props.stateWiseData || {})
                                      .length !== 0
                                  ? this.calculatePhysicalProgress(
                                      this.props.stateWiseData,
                                      index
                                    )
                                  : selectedPhysicalProgress
                                  ? selectedPhysicalProgress
                                  : ""
                              }
                            />
                            <span className="percent-suffix">%</span>
                          </div>
                        </Form.Group>
                      </div>
                      {/* Financial Progress */}
                      <div className="phase-name-wrapper progress-wrapper">
                        <div
                          className="table-name"
                          data-test="label-financial-progress"
                        >
                          Financial Progress
                        </div>

                        <Form.Group>
                          <div className="form-field">
                            <Form.Control
                              type="number"
                              // disabled={this.props.groupId == 166}
                              onChange={e => {
                                onChange(
                                  e.target.value,
                                  "financialProgress",
                                  bucketId,
                                  null,
                                  null,
                                  index
                                );
                              }}
                              value={
                                selectedFinancialProgress
                                  ? selectedFinancialProgress
                                  : ""
                              }
                            />
                            <span className="percent-suffix">%</span>
                          </div>
                        </Form.Group>
                      </div>
                      {/* Progress as of date */}
                      <div className="phase-name-wrapper progress-wrapper progress-as-of">
                        <div
                          className="table-name"
                          data-test="label-progress-as-of-date"
                        >
                          Progress As of date
                          {(selectedPhysicalProgress ||
                            selectedFinancialProgress) && (
                            <span className="required">*</span>
                          )}
                        </div>

                        <Form.Group>
                          <div
                            className={`form-field${
                              !selectedPhysicalProgress &&
                              !selectedFinancialProgress
                                ? " progress-as-of-disabled"
                                : ""
                            }`}
                          >
                            <DatePickerStyled
                              isClearable={selectedAsOfDate}
                              value={selectedAsOfDate}
                              selected={selectedAsOfDate}
                              onChange={value => {
                                onChange(
                                  value,
                                  "asOfDate",
                                  bucketId,
                                  null,
                                  null,
                                  index
                                );
                              }}
                              disabled={
                                !selectedPhysicalProgress &&
                                !selectedFinancialProgress
                              }
                              className={
                                (selectedPhysicalProgress ||
                                  selectedFinancialProgress) &&
                                isMilestoneTableValidated === false &&
                                !selectedAsOfDate
                                  ? " error-milestone"
                                  : ""
                              }
                              setZIndex={this.ZIndex}
                            />
                          </div>
                        </Form.Group>
                      </div>
                      {/* Project Proponent */}
                      <div className="phase-name-wrapper progress-wrapper">
                        <div
                          className="table-name"
                          data-test="label-project-proponent"
                        >
                          Project Proponent
                          <span className="required">*</span>
                        </div>
                        <Form className="project-by-filters">
                          <Form.Group className="field-select">
                            <Form.Control
                              value={selectedPhaseProponentId}
                              as="select"
                              onChange={e => {
                                onChange(
                                  { id: e.target.value, name: e.target.name },
                                  "projectProponent",
                                  bucketId,
                                  null,
                                  null,
                                  index
                                );
                              }}
                              name="projectProponent"
                              data-test="project-proponent"
                            >
                              {_projectPPList.map(val => (
                                <option value={val.id} name={val.name}>
                                  {val.name} ({val.userID})
                                </option>
                              ))}
                            </Form.Control>
                          </Form.Group>
                        </Form>
                      </div>

                      {!displayButtonForComplete &&
                      canDeletePhase &&
                      (openMilestoneEdit
                        ? projectMilestoneStatus !== "DRAFT" ||
                          (!get(item, "milestoneTable.id") &&
                            !get(item, "milestoneTable.predefined"))
                        : true) ? (
                        <div className="table-btns">
                          <div
                            data-test="delete-phase-button"
                            className="delete-phase-btn"
                            onClick={event => {
                              this.deletePhase(index);
                              event.stopPropagation();
                            }}
                          >
                            <img src={deletePhaseIcon} alt="delete phase" />
                          </div>
                        </div>
                      ) : null}
                    </div>

                    <div className={`${isBucketDisabled ? "hide-table" : ""}`}>
                      <MilestoneTable
                        milestones={milestoneData}
                        defaultMilestoneData={this.getDefaultBucketMilestones(
                          bucketId,
                          milestoneData
                        )}
                        ZIndex={this.ZIndex}
                        bucketId={bucketId}
                        cabinetbucketId={cabinetbucketId}
                        isCabinetMilestoneMandatoryExempt={
                          isCabinetMilestoneMandatoryExempt
                        }
                        isCabinetMilestoneMandatoryEditExempt={
                          isCabinetMilestoneMandatoryEditExempt
                        }
                        isEdit={isEdit}
                        sponsoredByCategory={sponsoredByCategory}
                        onChange={onChange}
                        cabinetMilestone={cabinetMilestone}
                        //milestoneDataCOS={_milestoneDataCOS || []}
                        responsibleAuthority={responsibleAuthority}
                        tableIndex={index}
                        bucketMilestoneCOS={bucketMilestoneCOS}
                        createMilestoneAction={createMilestoneAction}
                        openedFromComplete={openedFromComplete}
                        saveNewMilestoneAction={saveNewMilestoneAction}
                        deleteNewMilestoneAction={deleteNewMilestoneAction}
                        milestoneError={milestoneError}
                        handleTableOrder={handleTableOrder}
                        draftMilestoneAction={draftMilestoneAction}
                        isBucketCompleted={isBucketCompleted}
                        groupCategory={groupCategory}
                        openMilestoneEdit={openMilestoneEdit}
                        projectDetailBucketMilestoneCOS={
                          projectDetailBucketMilestoneCOS
                        }
                        checkIssueBeforeDeletion={checkIssueBeforeDeletion}
                        projectId={projectId}
                        checkIssueBeforeDisable={checkIssueBeforeDisable}
                        editMilestoneOriginalDate={editMilestoneOriginalDate}
                        isMilestoneTableValidated={isMilestoneTableValidated}
                      />
                    </div>
                    <div
                      className={`${
                        !displayButtonForComplete &&
                        index === tableArr.length - 1
                          ? "table-add-phase-wrapper"
                          : ""
                      }${isBucketDisabled ? " hide-table" : ""}`}
                      style={{
                        display: cabinetbucketId ? "none" : null
                      }}
                    >
                      {!displayButtonForComplete &&
                      index === tableArr.length - 1 ? (
                        <button
                          className="add-phase-btn"
                          onClick={e => this.addPhase(e)}
                          data-test="add-phase-button"
                        >
                          Add Phase
                        </button>
                      ) : null}
                    </div>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        {bucketMilestoneCOS.every(item => item.disabled === true) ? null : (
          <Form.Control.Feedback
            type="invalid"
            className={`${milestoneError ? "error-show" : ""}`}
          >
            {get(milestoneError, "message")}
          </Form.Control.Feedback>
        )}
      </div>
    );
  }
}

export default MultipleMilestoneTable;
